import {Component, ContentChild, input, TemplateRef} from '@angular/core';
import {Panel} from 'primeng/panel';
import {NgTemplateOutlet} from '@angular/common';
import {SharedModule} from 'primeng/api';

@Component({
  selector: 'app-page-panel',
    imports: [
        Panel,
        NgTemplateOutlet,
        SharedModule,
    ],
  templateUrl: './page-panel.component.html',
  styleUrl: './page-panel.component.scss'
})
export class PagePanelComponent {

    clipContent = input<boolean>(false);
    addPanelPadding = input<boolean>(false);
    addPanelMargin = input<boolean>(false);

    @ContentChild('header', { descendants: false }) headerTemplate: TemplateRef<void> | undefined;
    @ContentChild('icons', { descendants: false }) iconsTemplate: TemplateRef<void> | undefined;

}
